module.exports = __webpack_public_path__ + "static/media/facebook.6675d650.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/facebook.svg
// module id = 241
// module chunks = 0